module.exports = __webpack_public_path__ + "img/hero-lg.dd1d3363.png";